/**
 * selling-plans-alt — Style 5 (checkbox qty).
 * Drives the element's own plan / variant radios. Card prices come from Liquid
 * data-*. Plans from data-cb-plan-id (name contains 40 or 80).
 */
(function () {
  'use strict';

  if (window.__norseSellingPlansAltCheckbox) return;
  window.__norseSellingPlansAltCheckbox = true;

  /** Exact cents. See Money.displayCents in selling-plans-alt.js for why this is not rounded. */
  function displayCents(cents) {
    return Math.round(Number(cents) || 0);
  }

  /** `money_without_trailing_zeros` parity: drop the decimals only when they are zero. */
  function hideZeroDecimals(formatted) {
    return String(formatted || '').replace(/([.,])00(?!\d)/, '');
  }

  function formatMoney(spl, cents) {
    if (spl && typeof spl.formatMoney === 'function') return spl.formatMoney(cents);
    cents = displayCents(cents);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return hideZeroDecimals(window.Shopify.formatMoney(cents));
    }
    return hideZeroDecimals((cents / 100).toFixed(2));
  }

  function percentOff(compare, sale) {
    if (!compare || compare <= sale) return 0;
    return Math.round(((compare - sale) / compare) * 100);
  }

  function offerFor(card, sub, money) {
    var kit = parseInt(card.getAttribute('data-cb-kit'), 10) || 1;
    var otLine = parseInt(card.getAttribute('data-cb-ot-line'), 10) || 0;
    var subLine = parseInt(card.getAttribute('data-cb-sub-line'), 10) || 0;
    var compareLine = parseInt(card.getAttribute('data-cb-compare-line'), 10) || 0;
    var saleLine = sub && subLine > 0 ? subLine : otLine;
    if (!(compareLine > saleLine)) compareLine = 0;
    var perJar = kit >= 2;
    var qty = perJar ? kit : 1;
    var saleLineRounded = displayCents(saleLine);
    var compareLineRounded = compareLine > 0 ? displayCents(compareLine) : 0;
    var saleUnit = perJar ? saleLineRounded / qty : saleLineRounded;
    var compareUnit =
      compareLineRounded > saleLineRounded ? (perJar ? compareLineRounded / qty : compareLineRounded) : 0;
    var savePct = percentOff(compareLine, saleLine);
    var saveP = compareLine > saleLine ? compareLine - saleLine : 0;
    return {
      sale: money(saleUnit),
      lineMoney: money(saleLine),
      saleLine: saleLine,
      compare: compareUnit > saleUnit ? money(compareUnit) : '',
      compareLine: compareLine,
      perJar: perJar,
      unit: card.getAttribute('data-cb-unit') || 'jar',
      savePct: savePct,
      badge: savePct > 0 ? savePct + '% off' : '',
      meta: kit * 40 + '-Day Supply' + (saveP > 0 ? ' | Save ' + money(saveP) : ''),
    };
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function priceInner(offer) {
    var unit = offer.perJar ? '<span class="ig-nbcheck__unit">/' + escapeHtml(offer.unit) + '</span>' : '';
    var cmpClass = 'ig-nbcheck__compare' + (offer.compare ? '' : ' is-hidden');
    return (
      '<span class="ig-nbcheck__sale">' +
      offer.sale +
      unit +
      '</span><span class="' +
      cmpClass +
      '"><span class="ig-nbcheck__compare-amount">' +
      (offer.compare || '') +
      '</span>' +
      (offer.compare && offer.perJar ? unit : '') +
      '</span>'
    );
  }

  function clickNative(el, forceChange) {
    if (!el) return;
    if (el.checked && !forceChange) return;
    el.checked = true;
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function writePlan(spl, planId, sub) {
    planId = planId == null ? '' : String(planId);
    var delivery = spl.querySelector('.selling-plans-alt__delivery-input');
    if (delivery) {
      delivery.value = planId;
      delivery.dataset.sellingPlanId = planId;
      delivery.setAttribute('data-selling-plan-id', planId);
    }
    var subRadio = spl.querySelector(
      '.selling-plans-alt__option--subscription .selling-plans-alt__radio-input'
    );
    if (subRadio) {
      subRadio.value = planId;
      subRadio.dataset.sellingPlanId = planId;
    }
    var hidden = spl.querySelector('[data-selling-plan-input]');
    if (hidden) {
      hidden.value = sub ? planId : '';
      if (!hidden.getAttribute('name')) hidden.setAttribute('name', 'selling_plan');
    }
    var formId = hidden && hidden.getAttribute('form');
    var form = formId ? document.getElementById(formId) : null;
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (el) {
      if (el === hidden) return;
      var via = el.getAttribute('form');
      var same = (formId && via === formId) || (form && !via && form.contains(el));
      if (!same) return;
      el.value = '';
      el.removeAttribute('name');
      el.disabled = true;
    });
    var prop = spl.querySelector('[data-cb-plan-prop]');
    if (prop) prop.value = planId;
  }

  function attach(spl) {
    if (!spl || !spl.classList.contains('style-5')) return;
    if (spl.dataset.spaCheckboxReady === 'true') return;
    var ui = spl.querySelector('[data-ig-nbcheck]');
    if (!ui) return;
    spl.dataset.spaCheckboxReady = 'true';

    function money(cents) {
      return formatMoney(spl, cents);
    }

    function currentState() {
      var qty = ui.querySelector('.ig-nbcheck__qty input:checked');
      var sub = ui.querySelector('.ig-nbcheck__sub input[type="checkbox"]');
      return {
        kit: qty ? parseInt(qty.value, 10) || 1 : 1,
        sub: Boolean(sub && sub.checked),
      };
    }

    function selectedCard() {
      return ui.querySelector('.ig-nbcheck__card[data-cb-kit="' + currentState().kit + '"]');
    }

    function selectAvailableKit() {
      var checked = ui.querySelector('.ig-nbcheck__qty input:checked');
      var checkedCard = checked && checked.closest('.ig-nbcheck__card');
      if (checkedCard && checkedCard.getAttribute('data-cb-available') !== 'false') return;
      var cards = ui.querySelectorAll('.ig-nbcheck__card');
      var nextInput = null;
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getAttribute('data-cb-available') === 'false') continue;
        nextInput = cards[i].querySelector('input[type="radio"]');
        if (nextInput) break;
      }
      if (!nextInput) return;
      var inputs = ui.querySelectorAll('.ig-nbcheck__qty input[type="radio"]');
      for (var j = 0; j < inputs.length; j++) {
        inputs[j].checked = inputs[j] === nextInput;
      }
    }

    function paint() {
      var state = currentState();
      ui.querySelectorAll('.ig-nbcheck__card').forEach(function (card) {
        var kit = parseInt(card.getAttribute('data-cb-kit'), 10);
        var on = kit === state.kit;
        card.classList.toggle('is-selected', on);
        var soldOut = card.getAttribute('data-cb-available') === 'false';
        card.classList.toggle('is-sold-out', soldOut);
        if (soldOut) card.setAttribute('aria-disabled', 'true');
        else card.removeAttribute('aria-disabled');
        var input = card.querySelector('input[type="radio"]');
        if (input) {
          input.disabled = soldOut;
          input.checked = on;
          if (on) input.setAttribute('checked', 'checked');
          else input.removeAttribute('checked');
          if (soldOut) input.setAttribute('disabled', 'disabled');
          else input.removeAttribute('disabled');
        }
        var offer = offerFor(card, state.sub, money);
        if (!offer.lineMoney) return;
        var badge = card.querySelector('.ig-nbcheck__badge');
        var meta = card.querySelector('.ig-nbcheck__meta');
        var prices = card.querySelector('.ig-nbcheck__prices');
        if (badge) {
          badge.textContent = soldOut ? 'Sold out' : offer.badge || '';
          badge.classList.toggle('is-hidden', !soldOut && !offer.badge);
        }
        if (meta) meta.textContent = offer.meta;
        if (prices) prices.innerHTML = priceInner(offer);
      });
      var subBox = ui.querySelector('.ig-nbcheck__sub');
      var subInput = subBox && subBox.querySelector('input[type="checkbox"]');
      if (subBox) subBox.classList.toggle('is-checked', state.sub);
      if (subInput) {
        subInput.checked = state.sub;
        if (state.sub) subInput.setAttribute('checked', 'checked');
        else subInput.removeAttribute('checked');
      }
      /* The help line quotes the renewal saving of the SELECTED kit. The figure is
       * Liquid's (presentment money) — this only moves it between kits; a kit with
       * nothing to quote gets the fallback, never "0% OFF". */
      var help = ui.querySelector('[data-cb-renewal-help]');
      if (help) {
        var helpCard = selectedCard();
        var renewalPct = helpCard
          ? parseInt(helpCard.getAttribute('data-cb-renewal-pct'), 10) || 0
          : 0;
        var helpTpl = help.getAttribute('data-cb-help-template') || '';
        var helpFallback = help.getAttribute('data-cb-help-fallback') || '';
        help.textContent =
          renewalPct > 0 && helpTpl
            ? helpTpl.replace('{renewal_pct}', String(renewalPct))
            : helpFallback || help.textContent;
      }
    }

    function paintChrome() {
      var state = currentState();
      var card = selectedCard();
      if (!card) return;
      var offer = offerFor(card, state.sub, money);
      var subPrice = spl.querySelector('[data-subscription-price]');
      var otPrice = spl.querySelector('[data-onetime-price]');
      if (state.sub && subPrice && offer.lineMoney) subPrice.textContent = offer.lineMoney;
      if (!state.sub && otPrice && offer.lineMoney) otPrice.textContent = offer.lineMoney;
      if (typeof spl.updateButtonText === 'function') spl.updateButtonText();
      var sectionId = spl.dataset.sectionId || '';
      var gallery = document.getElementById('MediaGallery-' + sectionId);
      if (gallery && typeof gallery.setSavePercent === 'function') {
        gallery.setSavePercent(offer.savePct);
      }
      var compareRounded = displayCents(offer.compareLine || 0);
      var saleRounded = displayCents(offer.saleLine || 0);
      document.dispatchEvent(
        new CustomEvent('selling-plans-alt:sticky-sync', {
          bubbles: true,
          detail: {
            productSectionId: sectionId,
            variantId: card.getAttribute('data-cb-variant-id') || '',
            variantAvailable: card.getAttribute('data-cb-available') !== 'false',
            subSavePercent: offer.savePct,
            subscriptionMoney: offer.lineMoney,
            compareMoney: compareRounded > saleRounded ? money(compareRounded) : offer.lineMoney,
            subscriptionLineRoundedCents: saleRounded,
            compareDisplayCents: compareRounded,
            showCompareStrikethrough: compareRounded > saleRounded,
          },
        })
      );
    }

    function pinCardPlan(state, card) {
      var planId = (card && card.getAttribute('data-cb-plan-id')) || '';
      writePlan(spl, planId, state.sub);
      if (typeof spl.updateSellingPlan === 'function') {
        spl.updateSellingPlan(state.sub ? planId : '');
      }
    }

    function applyNative() {
      var state = currentState();
      var card = selectedCard();
      var variantId = (card && card.getAttribute('data-cb-variant-id')) || '';
      pinCardPlan(state, card);
      var col = state.sub
        ? '.selling-plans-alt__option--subscription'
        : '.selling-plans-alt__option--onetime';
      clickNative(spl.querySelector(col + ' .selling-plans-alt__radio-input'), true);
      var variantInput =
        spl.querySelector(col + ' .selling-plans-alt__variant-input[data-kit-count="' + state.kit + '"]') ||
        spl.querySelector('.selling-plans-alt__variant-input[data-kit-count="' + state.kit + '"]');
      if (variantInput) clickNative(variantInput, true);
      if (variantId && typeof spl.syncAllVariantRadios === 'function') {
        spl.syncAllVariantRadios(variantId);
      }
      pinCardPlan(state, card);
      paintChrome();
    }

    function sync() {
      selectAvailableKit();
      paint();
      applyNative();
    }

    ui.querySelectorAll('.ig-nbcheck__card').forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (card.getAttribute('data-cb-available') !== 'false') return;
        event.preventDefault();
      });
    });

    ui.querySelectorAll('.ig-nbcheck__qty input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var card = input.closest('.ig-nbcheck__card');
        if (card && card.getAttribute('data-cb-available') === 'false') input.checked = false;
        sync();
      });
    });

    var subInput = ui.querySelector('.ig-nbcheck__sub input[type="checkbox"]');
    if (subInput) subInput.addEventListener('change', sync);

    sync();
  }

  function injectAll() {
    document.querySelectorAll('selling-plans-alt.style-5').forEach(attach);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('selling-plans-alt').then(injectAll);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectAll);
  } else {
    injectAll();
  }
})();
